// extracted by css-extract-rspack-plugin
export default {"filterTag":"FilterTag__filterTag--em2oC","active":"FilterTag__active--XLkrX"};